<div class="grid">
	<div class="col-12">
		<div class="flex align-items-center justify-content-center flex-column">
			<div class="text-lg font-medium mb-3">
				<div class="pi cm-user pr-1"></div>
				{{ 'INFO' | translate }}
			</div>
			<div class="flex align-items-center justify-content-center text-center flex-column gap-3">
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'CUSTOMER_NAME' | translate }}: <div class="font-medium">{{ permission.Name }}</div></div>
				<div *ngIf="permission.Description !== ''" class="flex flex-row align-items-center justify-content-center gap-2">{{ 'DESCRIPTION' | translate }}: <div class="font-medium">{{ permission.Description }}</div></div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'EMAIL' | translate }}: <div class="font-medium">{{ permission.Email }}</div></div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'LANGUAGE' | translate }}: 
					<img alt="{{ permission.CustomerLanguage }}" [src]="getCurrentLanguageFlag(permission.CustomerLanguage)" class="w-2rem">
					<div class="font-medium">{{ getLanguage(permission.CustomerLanguage) }}</div>
				</div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'STATUS' | translate }}: 
					<p-tag [value]="permission.Status?.toUpperCase() | translate" [severity]="getColorStatus(permission.Status)"></p-tag>
				</div>
			</div>
			<div class="text-lg font-medium mt-5 mb-3">
				<div class="pi cm-date-time pr-1"></div>
				{{ 'TIME_INFO' | translate }}
			</div>
			<div class="flex align-items-center justify-content-center text-center flex-column gap-3">
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'TIMEZONE' | translate }}: <div class="font-medium">{{ permission.Tz }}</div></div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'PERMISSION' | translate }} {{ 'CREATED_AT' | translate | lowercase }}: <div class="font-medium">{{ permission.CreatedAt | localizedDate:'short' }}</div></div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'START_DATE_TIME' | translate }}: <div class="font-medium">{{ permission.Start | localizedDate:'short' }}</div></div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'END_DATE_TIME' | translate }}: <div class="font-medium">{{ permission.End | localizedDate:'short' }}</div></div>
			</div>
			<div class="text-lg font-medium mt-5 mb-3">
				<div class="pi cm-mail pr-1"></div>
				{{ 'SETTINGS_MAIL' | translate }}
			</div>
			<div class="flex align-items-center justify-content-center text-center flex-column gap-1">
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_MAIL' | translate }}:
					<p-tag [value]="permission.SendMail ? ( 'SENT' | translate ) : ( 'NOT_SENT' | translate )" 
						[styleClass]="permission.SendMail ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_ACCESS_MAIL' | translate }}:
					<p-tag [value]="permission.SendAccessMail ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )" 
						[styleClass]="permission.SendAccessMail ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
			</div>
			<div class="text-lg font-medium mt-5 mb-3">
				<div class="pi cm-keypad pr-1"></div>
				{{ 'RADIOCOMANDO_KEYBOARD' | translate }}
			</div>
			<div class="flex align-items-center justify-content-center text-center flex-column gap-1">
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_TO_RBE' | translate }}:
					<p-tag [value]="permission.SendPincodeRbe ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )" 
						[styleClass]="permission.SendPincodeRbe ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_TO_MTMA' | translate }}:
					<p-tag [value]="permission.SendPincodeMtma ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )" 
						[styleClass]="permission.SendPincodeMtma ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
			</div>
			<div class="text-lg font-medium mt-5 mb-3">
				<div class="pi cm-card pr-1"></div>
				{{ 'SINGLE_RFID_CARD' | translate }}
			</div>
			<div class="flex align-items-center justify-content-center text-center flex-column gap-1">
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_TO_RBE' | translate }}:
					<p-tag [value]="permission.SendRfidRbe ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )" 
						[styleClass]="permission.SendRfidRbe ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
				<div class="flex flex-row align-items-center justify-content-center gap-2">{{ 'SEND_TO_MTMA' | translate }}:
					<p-tag [value]="permission.SendRfidMtma ? ( 'MTMA_CONF_{Enabled}' | translate ) : ( 'MTMA_CONF_{Disabled}' | translate )" 
						[styleClass]="permission.SendRfidMtma ? 'p-tag-success' : 'p-tag-darkBlue10'"></p-tag>
				</div>
			</div>
			<div class="text-lg font-medium mt-5 mb-3">
				<div class="pi cm-configuration pr-1"></div>
				{{ 'PERMITTED_COMMANDS' | translate }}
			</div>
			<div *ngIf="(permission.Commands) && (permission.Commands.length !== 0)">
				<div class="flex w-full justify-content-center align-items-center text-lg pb-3">{{ setFirstDeviceName(permission.Commands[0].DeviceName) }}</div>
				<div *ngFor="let cmd of permission.Commands">
					<div *ngIf="getGroup(cmd)" class="flex w-full justify-content-center text-lg py-3">
						{{ cmd.DeviceName }}
					</div>
					<p-tag [value]="cmd.CommandDescription" severity="info" class="flex w-full justify-content-center py-1"></p-tag>
				</div>
			</div>
			<div *ngIf="(permission.Commands) && (permission.Commands.length === 0)" class="grid">
				<div class="col-12 flex align-items-center justify-content-center">
					<p-tag icon="pi cm-alert" value="{{'TABLE_NO_ELEMENT' | translate}}" severity="warning"></p-tag>
				</div>
			</div>
		</div>
	</div>

	<div class="col-12 mt-3 flex justify-content-center">
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>